export const SURVEY_LOADING = "SURVEY_LOADING";
export const SURVEY_RESET = "SURVEY_RESET";
export const GET_SURVEY = "GET_SURVEY";
export const GET_SURVEY_SUCCESS = "GET_SURVEY_SUCCESS";
export const GET_SURVEY_FAIL = "GET_SURVEY_FAIL";
export const DELETE_SURVEY = "DELETE_SURVEY";
export const DELETE_SURVEY_SUCCESS = "DELETE_SURVEY_SUCCESS";
export const DELETE_SURVEY_FAIL = "DELETE_SURVEY_FAIL";
export const UPDATE_SURVEY = "UPDATE_SURVEY";
export const UPDATE_SURVEY_SUCCESS = "UPDATE_SURVEY_SUCCESS";
export const UPDATE_SURVEY_FAIL = "UPDATE_SURVEY_FAIL";
export const ADD_NEW_SURVEY = "ADD_NEW_SURVEY";
export const ADD_SURVEY_SUCCESS = "ADD_SURVEY_SUCCESS";
export const ADD_SURVEY_FAIL = "ADD_SURVEY_FAIL";
